import { buildConfigApiUrl } from '@api/api';

const getHeaders = () => ({
  'Content-Type': 'application/json',
});

const fetchBothStatusTypes = async () => {
  const [hostResponse, metricResponse] = await Promise.all([
    fetch(buildConfigApiUrl('/statuses?type=host'), {
      method: 'GET',
      headers: getHeaders(),
      credentials: 'include',
    }),
    fetch(buildConfigApiUrl('/statuses?type=metric'), {
      method: 'GET',
      headers: getHeaders(),
      credentials: 'include',
    }),
  ]);

  if (!hostResponse.ok || !metricResponse.ok) {
    throw new Error(`HTTP error! status: ${hostResponse.status} / ${metricResponse.status}`);
  }

  const hostData = await hostResponse.json();
  const metricData = await metricResponse.json();

  return { hostData, metricData };
};

/**
 * Fetch available host states and metric statuses from Centerity API
 * @returns {Promise<Object>} Object with hostStatuses and metricStatuses arrays
 */
export async function fetchStatuses() {
  try {
    const { hostData, metricData } = await fetchBothStatusTypes();

    const hostStatuses = (hostData.statuses || [])
      .filter(status => !status.is_deleted)
      .map(status => ({
        value: status.id,
        label: status.display_name,
      }));

    const metricStatuses = (metricData.statuses || [])
      .filter(status => !status.is_deleted)
      .map(status => ({
        value: status.id,
        label: status.display_name,
      }));

    return {
      hostStatuses,
      metricStatuses,
    };
  } catch {
    return {
      hostStatuses: [],
      metricStatuses: [],
    };
  }
}

/**
 * Fetch a color map for all statuses, keyed by both display_name and id.
 * Used by chart widgets to apply correct severity colors.
 * @returns {Promise<{ byDisplayName: Object<string, string>, byId: Object<string, string> }>}
 */
export async function fetchStatusColorMap() {
  try {
    const { hostData, metricData } = await fetchBothStatusTypes();

    const colorMap = { byDisplayName: {}, byId: {} };

    [hostData, metricData].forEach(({ statuses }) => {
      (statuses || [])
        .filter(s => !s.is_deleted && s.status_color)
        .forEach(status => {
          colorMap.byDisplayName[status.display_name] = status.status_color;
          colorMap.byId[status.id] = status.status_color;
        });
    });

    return colorMap;
  } catch (err) {
    console.warn('fetchStatusColorMap failed:', err);
    return { byDisplayName: {}, byId: {} };
  }
}
